import posthog from 'posthog-js';

import { setInvitationHandoffReporter } from '../auth/invitationHandoffEvents';
import { consoleConfig } from '../config';
import {
  buildInvitationAnalyticsCapture,
  invitationAnalyticsPropertyDenylist,
  stripInvitationCallbackProperties,
} from './invitationAnalyticsContract';

/**
 * Install the console's intentionally narrow PostHog client.
 *
 * It never identifies a Stytch member or creates a person profile. The callback
 * URL and referrer are stripped because either may contain a one-time invite
 * token before authentication finishes.
 */
export function initializeInvitationAnalytics(): void {
  const client = posthog.init(consoleConfig.posthogPublicKey, {
    autocapture: false,
    capture_pageview: false,
    capture_pageleave: false,
    capture_heatmaps: false,
    capture_exceptions: false,
    disable_session_recording: true,
    disable_surveys: true,
    disable_web_experiments: true,
    advanced_disable_flags: true,
    person_profiles: 'never',
    respect_dnt: true,
    opt_out_capturing_by_default: false,
    opt_out_capturing_persistence_type: 'localStorage',
    property_denylist: invitationAnalyticsPropertyDenylist,
    before_send: (event) => {
      if (!event) return null;
      event.properties = stripInvitationCallbackProperties(event.properties ?? {});
      return event;
    },
  });

  setInvitationHandoffReporter((event, properties) => {
    try {
      const payload = buildInvitationAnalyticsCapture(event, properties);
      client.capture(payload.event, payload.properties);
    } catch (cause) {
      console.warn('[analytics] rejected invitation event', cause);
    }
  });
}
